/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SeekDirection = {
    prev: 'prev',
    next: 'next'
} as const;
export type SeekDirection = typeof SeekDirection[keyof typeof SeekDirection];

